import {
    UPDATE_EVALUATION,

    GET_EVALUATION_REQUEST,
    GET_EVALUATION_SUCCESS,
    GET_EVALUATION_FAIL,

    GET_ALL_EVALUATIONS_REQUEST,
    GET_ALL_EVALUATIONS_SUCCESS,
    GET_ALL_EVALUATIONS_FAIL,

    GET_EVALUATIONS_BY_TYPE_REQUEST,
    GET_EVALUATIONS_BY_TYPE_SUCCESS,
    GET_EVALUATIONS_BY_TYPE_FAIL,

    CREATE_EVALUATION_REQUEST,
    CREATE_EVALUATION_SUCCESS,
    CREATE_EVALUATION_FAIL,

    UPDATE_EVALUATION_REQUEST,
    UPDATE_EVALUATION_SUCCESS,
    UPDATE_EVALUATION_FAIL,

    DELETE_EVALUATION_REQUEST,
    DELETE_EVALUATION_SUCCESS,
    DELETE_EVALUATION_FAIL,

    CHANGE_EVALUATION_STATUS_REQUEST,
    CHANGE_EVALUATION_STATUS_SUCCESS,
    CHANGE_EVALUATION_STATUS_FAIL,

    SET_EVALUATION_LOADING,
    CLEAR_EVALUATION_ERROR
} from "../actions/evaluationActions";

const initialState = {
    evaluations: [],
    currentEvaluation: null,
    loading: false,
    message: "",
    error: null
};

function evaluationReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_EVALUATION:
            return {
                ...state,
                currentEvaluation: action.evaluation,
                loading: false
            };

        case SET_EVALUATION_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case CLEAR_EVALUATION_ERROR:
            return {
                ...state,
                error: null
            };

        case GET_EVALUATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_EVALUATION_SUCCESS:
            return {
                ...state,
                currentEvaluation: action.payload,
                loading: false,
                message: "Évaluation récupérée avec succès"
            };

        case GET_EVALUATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: "Échec de récupération"
            };

        case GET_ALL_EVALUATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_EVALUATIONS_SUCCESS:
            return {
                ...state,
                evaluations: action.payload,
                loading: false,
                message: ""
            };

        case GET_ALL_EVALUATIONS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case GET_EVALUATIONS_BY_TYPE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_EVALUATIONS_BY_TYPE_SUCCESS:
            return {
                ...state,
                evaluations: action.payload,
                loading: false,
                message: ""
            };

        case GET_EVALUATIONS_BY_TYPE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case CREATE_EVALUATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CREATE_EVALUATION_SUCCESS:
            return {
                ...state,
                evaluations: [...state.evaluations, action.payload],
                currentEvaluation: action.payload,
                loading: false,
                message: ""
            };

        case CREATE_EVALUATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case UPDATE_EVALUATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case UPDATE_EVALUATION_SUCCESS:
            return {
                ...state,
                evaluations: state.evaluations.map((evaluation) =>
                    evaluation.id === action.payload.id ? action.payload : evaluation
                ),
                currentEvaluation:
                    state.currentEvaluation?.id === action.payload.id
                        ? action.payload
                        : state.currentEvaluation,
                loading: false,
                message: ""
            };

        case UPDATE_EVALUATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case DELETE_EVALUATION_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case DELETE_EVALUATION_SUCCESS:
            return {
                ...state,
                evaluations: state.evaluations.filter(
                    (evaluation) => evaluation.id !== action.payload.evaluationId
                ),
                currentEvaluation:
                    state.currentEvaluation?.id === action.payload.evaluationId
                        ? null
                        : state.currentEvaluation,
                loading: false,
                message: ""
            };

        case DELETE_EVALUATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case CHANGE_EVALUATION_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case CHANGE_EVALUATION_STATUS_SUCCESS:
            return {
                ...state,
                evaluations: state.evaluations.map((evaluation) =>
                    evaluation.id === action.payload.id ? action.payload : evaluation
                ),
                currentEvaluation:
                    state.currentEvaluation?.id === action.payload.id
                        ? action.payload
                        : state.currentEvaluation,
                loading: false,
                message: ""
            };

        case CHANGE_EVALUATION_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default evaluationReducer;